import { Fragment, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FilePageService from "../../API/FilePage/FilePageService";
import { MultiSelect } from "react-multi-select-component";
import Loading from "../../Common/Loading";

const EditQRBasis = (props) => {
  const { t } = useTranslation();
  const {
    showmodal,
    handleModalClose,
    handleEditQRBasisModalCloseAfterAPICall,
    selectedId,
    insurerProductList,
    questionsList,
    formData,
    setFormData
  } = props;

  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const isBlank = formData.name == "" && formData.insurer_product_id == "" && formData.questions_id.length == 0;
    setLoading(isBlank);
  }, [formData]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => {
        setFlashMessage({ type: "", message: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (selected) => {
    setFormData((prev) => ({ ...prev, questions_id: selected }));
  };

  const UpdateProduct = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!formData.name || !formData.insurer_product_id || !formData.questions_id.length) {
      setFlashMessage({ type: "error", message: t("requriedErrorMessageLabel") });
      return;
    }

    setLoading(true);

    const payload = {
      name: formData.name,
      insurer_product_id: formData.insurer_product_id,
      questions_id: formData.questions_id.map((q) => q.value),
    };

    try {
      const response = await FilePageService.qr_basis_update(selectedId, payload);
      if (response.data.status) {
        setFlashMessage({ type: "success", message: t("updatedSuccessfully") });
        handleEditQRBasisModalCloseAfterAPICall();
      } else {
        setFlashMessage({
          type: "error",
          message: response.data.message || t("somethingWentWrong"),
        });
      }
    } catch (error) {
      setFlashMessage({
        type: "error",
        message: error.response?.data?.message || t("somethingWentWrong"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Modal
        className="missing-doc-modal invalid-doc-modal"
        show={showmodal}
        onHide={handleModalClose}
      >
        <Form onSubmit={UpdateProduct}>
          <Modal.Header closeButton>
            <Modal.Title>Modifier la base QR</Modal.Title>
          </Modal.Header>
          {loading ? <Loading /> :
            <>
              <Modal.Body>
                <h2>Modifier la base QR</h2>

                {flashMessage.message && (
                  <div
                    className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                      ? "alert-success"
                      : "alert-danger"
                      } text-center`}
                    role="alert"
                  >
                    {flashMessage.message}
                  </div>
                )}
                <div className="mt-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Nom de la base QR</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Nom de la base QR"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Produit assureur</Form.Label>
                    <Form.Select
                      name="insurer_product_id"
                      value={formData.insurer_product_id}
                      onChange={handleChange}
                    >
                      <option value="">sélectionner une option</option>
                      {insurerProductList?.length > 0 ? (
                        insurerProductList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      ) : (
                        <option disabled>{t("NorecordsfoundLabel")}</option>
                      )}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Questions</Form.Label>
                    <MultiSelect
                      options={questionsList}
                      value={formData.questions_id}
                      onChange={handleMultiSelectChange}
                      labelledBy="Sélectionner les questions"
                      overrideStrings={{
                        selectSomeItems: "Sélectionner les questions",
                        allItemsAreSelected: "Toutes sélectionnées",
                        selectAll: "Tout sélectionner",
                        search: "Rechercher...",
                      }}
                    />
                  </Form.Group>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button className="cancel-btn" variant="primary" onClick={handleModalClose}>
                  {t("cancelLabel")}
                </Button>
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? "Mise à jour..." : "Mise à jour"}
                </Button>
              </Modal.Footer>
            </>
          }
        </Form>
      </Modal>
    </Fragment>
  );
};

export default EditQRBasis;
